module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Code/Info-circle-baed312c2422c09715c5f562fe241e35.svg";